module.exports = __webpack_public_path__ + "static/media/a26.497a4117.pdf";